import { oz } from '@weft/utils';

export const GetCustomerCommitmentUsageResponseSchema = oz.object({
  customerCommitmentUsage: oz.array(
    oz.object({
      customerName: oz.string(),
      customerId: oz.string(),
      commitmentUnits: oz.number(),
      usageUnits: oz.number(),
    }),
  ),
});

export type GetCustomerCommitmentUsageResponse = oz.infer<typeof GetCustomerCommitmentUsageResponseSchema>;